import { CapoPlugin } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];